/**
 * A custom loading hook for showing loader
 *
 * @module utils/useLoader
 * @memberof -Common
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Loader from '../../views/components/Loader/Loader';

/**
 * Represents a useLoader component
 *
 * @method
 * @param {object} props - React properties passed from composition
 * @returns useLoader
 */
export const useLoader = ( props ) => {
  const [loading, setLoading] = useState( false );
  return [
    loading && <Loader color={ props.color }/>,
    () => setLoading( true ),
    () => setLoading( false )
  ];
};

/**
 * Property type definitions
 *
 * @type {object}
 * @property {string} color - sets the color to the loader
 */
export const propTypes =  {
  color: PropTypes.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} [color='orange-400'] - sets the color to the loader
 */
export const defaultProps =  {
  color: 'orange-400'
};

useLoader.propTypes = propTypes;
useLoader.defaultProps = defaultProps;

export default useLoader;
